import { useAppSelector } from "@src/reduxStore";
import { FC } from "react";
import { useIntl } from "react-intl";

const LinkToCustomerService: FC = ({ children }) => {
  const config = useAppSelector(state => state.common.config);
  const intl = useIntl();

  return (
    <a
      href={intl.formatMessage(
        {
          id: "customerServiceUrl",
          defaultMessage: "{vgUrl}/fi-fi/asiakaspalvelu",
        },
        {
          vgUrl: config?.vgUrl,
        }
      )}
      target="_blank"
      rel="noreferrer noopener"
    >
      {children}
    </a>
  );
};

export default LinkToCustomerService;
